<template>
  <section>
    <NbNumberedAccordionForm
      :id="'accord-form-shipment'"
      :twoPartFormDone="areBoxesOk"
      @firstFormDone="firstFormDone($event)"
      class="mb-2"
      accordionKey="shipment"
      :number="number"
      :title="$t('orderCreatePage.shipment')"
      :subTitle="$t('orderCreatePage.shipmentInformation.title')"
      :helpText="$t('orderCreatePage.shipmentInformation.helpText')"
      :hasError="sectionError"
      :errors="errors"
      :formInputs="shipmentInputs"
      @input="shipmentUpdated()"
      @updateValidFields="$emit('updateValidFields', $event)"
      @invalid="$emit('updateInvalidFields', $event)"
      :formVal.sync="shipment"
    >
      <NbBoxesList
        :errors="errors"
        :currency="shipment.currency"
        :quoteVersion="true"
        @itemAttributeValueUpdated="$emit('itemAttributeValueUpdated')"
        @boxMetricsChange="$emit('boxMetricsChange')"
        @updateValidFields="$emit('updateValidFields', $event)"
        @invalid="$emit('updateInvalidFields', $event)"
        :formValBoxes.sync="shipment.volumes_attributes"
      />
    </NbNumberedAccordionForm>
  </section>
</template>

<script>
import NbNumberedAccordionForm from "@/components/forms/NbNumberedAccordionForm.vue";
import NbBoxesList from "@/components/orders/create/shipment/NbBoxesList.vue";
import SalesChannelsManagementService from "@/services/SalesChannelManagementService";

const salesChannelManagementService = new SalesChannelsManagementService();

export default {
  components: {
    NbNumberedAccordionForm,
    NbBoxesList,
  },
  props: {
    /* value: {
      type: Object,
      required: true,
    }, */
    formVal: {
      type: Object,
      required: true,
    },
    quickStarts: {
      type: Array,
      required: false,
    },
    number: {
      type: Number,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
    sectionError: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      salesChannelOptions: [],
      incotermOptions: [
        { text: "Sender (DDP)", value: "DDP" },
        { text: "Receiver (DDU)", value: "DDU" },
      ],
      confirmOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      currencyOptions: [
        { text: "USD", value: "USD" },
        { text: "BRL", value: "R$" },
      ],
      products: [
        {
          sku: "",
          name: "",
          description: "",
          origin_country: "",
          category: "",
          hs_code: "",
          unit_price: 0,
          weight: 0.0,
          quantity: 1,
          box: "",
          total: 0.0,
        },
      ],
      areBoxesOk: false, //TODO: incompleto quando box/items blank
    };
  },
  created() {
    //this.shipment = { ...this.shipment, ...this.value.shipment };
  },
  methods: {
    getAndConfigureSalesChannels() {
      salesChannelManagementService.getSalesChannels().then(({ data }) => {
        const availableSalesChannels = data.data;
        this.salesChannelOptions = availableSalesChannels.map(
          ({ id, name }) => ({
            value: id,
            text: name,
          })
        );
        this.salesChannelOptions.unshift({
          value: null,
          text: "Select an option",
        });
      });
    },
    resetIsLandedCost(val) {
      this.shipment.is_landed_cost = val;
    },
    firstFormDone(event) {
      //test boxes (volumes_attributes) (may have a better way?)
      if (
        event &&
        this.shipment &&
        this.shipment.volumes_attributes &&
        this.shipment.volumes_attributes.length > 0
      ) {
        this.areBoxesOk = true;

        //test each volumes_attributes (box)
        this.shipment.volumes_attributes.forEach((box) => {
          if (
            this.areBoxesOk &&
            box.height &&
            box.weight &&
            box.width &&
            box.length
          ) {
            //test each order_items_attributes (product) in box
            this.areBoxesOk = box.order_items_attributes.every(
              (product) =>
                this.areBoxesOk &&
                product.name &&
                product.category &&
                product.hs_code &&
                product.weight &&
                Number(product.value) > 0 &&
                Number(product.quantity) > 0
            );
          } else {
            this.areBoxesOk = false;
          }
        });
        this.$emit("formDoneChangeShipment", this.areBoxesOk);
        return;
      }

      this.areBoxesOk = false;
      this.$emit("formDoneChangeShipment", this.areBoxesOk);
    },
    shipmentUpdated() {
      this.$emit("shipmentUpdated");
    },
  },
  computed: {
    shipment: {
      get() {
        return this.formVal;
      },
      set(val) {
        this.$emit("update:formVal", val);
      },
    },
    shipmentInputs() {
      let finalShipmentInputs = [
        {
          required: true,
          id: "incoterm",
          type: "radio",
          options: this.incotermOptions,
          name: this.$t("taxes"),
          classes: "mb-3 w-20",
          inputClasses: "display-block",
          key: "incoterm",
          error: this.errors.incoterm,
          helpText: this.$t(
            "orderCreatePage.shipmentInformation.incotermHelpText"
          ),
        },
        {
          required: this.isLandedCostRequired,
          id: "landed_cost",
          type: "checkbox",
          name: this.$t(
            "orderCreatePage.shipmentInformation.landedcostHelpText"
          ),
          nameHelpText: this.$t(
            "orderCreatePage.shipmentInformation.landedCost"
          ),
          classes: "w-22",
          key: "is_landed_cost",
          error: this.errors.is_landed_cost,
        },
        {
          required: true,
          id: "return_insurance",
          type: "checkbox",
          name: this.$t("includeInsurance"),
          nameHelpText: this.$t(
            "orderCreatePage.shipmentInformation.includeInsuranceNameHelpText"
          ),
          classes: "w-22 mt-4 pt-1",
          inputClasses: "display-block",
          key: "return_insurance",
          error: this.errors.return_insurance,
        },
        {
          required: true,
          id: "shipment_currency",
          type: "select",
          options: this.currencyOptions,
          name: this.$t("currency"),
          classes: "mb-3 w-32-5",
          key: "currency",
          error: this.errors.currency,
          helpText: this.$t(
            "orderCreatePage.shipmentInformation.currencyHelpText"
          ),
        },
      ];

      if (this.shipment.incoterm !== "DDP") {
        let customer_incoterm = finalShipmentInputs.find(
          (inputOption) => inputOption.id === "landed_cost"
        );
        customer_incoterm.classes = "anim-fade-disappear w-22 mt-4 pt-1 ";
        this.resetIsLandedCost(null);
      } else {
        this.resetIsLandedCost(false);
        let customer_incoterm = finalShipmentInputs.find(
          (inputOption) => inputOption.id === "landed_cost"
        );
        customer_incoterm.classes = "anim-fade-appear w-22 mt-4 pt-1";
      }

      return finalShipmentInputs;
    },
    isLandedCostRequired() {
      if (this.shipment.incoterm !== "DDP") {
        return false;
      }
      return true;
    },
  },
  watch: {
    /* shipment(newValue) {
      this.$emit("input", newValue);
    }, */
    formVal(/* newValue */) {
      //this.shipment = newValue;

      let newProducts = [];
      this.formVal.shipment.volumes_attributes.forEach((box) => {
        newProducts = [...newProducts, ...box.order_items_attributes];
      });
      if (newProducts.length) this.products = newProducts;
    },

    quickStarts() {
      this.quickStarts.forEach((quickStart) => {
        if (quickStart.incoterm) {
          this.shipment.incoterm = quickStart.incoterm;
        }
        if (quickStart["insurance"]) {
          this.shipment.return_insurance = quickStart.insurance;
        }
        if (quickStart.currency) {
          this.shipment.currency = quickStart.currency;
        }
        //fill category and hs_code
        if (quickStart.category) {
          this.products[0].category = quickStart.category;

          this.shipment.category = quickStart.category;
        }
        if (quickStart.hs_code) {
          this.products[0].hs_code = quickStart.hs_code;
          this.shipment.hs_code = quickStart.hs_code;
        }
        if (quickStart.origin_country) {
          this.products[0].origin_country = quickStart.origin_country;
          this.shipment.origin_country = quickStart.origin_country;
        }
        if (quickStart.sales_channel) {
          this.shipment.sales_channel_id = quickStart.sales_channel;
        }
        this.getAndConfigureSalesChannels();
      });
    },
    errors: {
      //deep: true,
      handler(newValue) {
        if (newValue.is_landed_cost && newValue.is_landed_cost.length > 0) {
          this.shipment.incoterm = "DDP";
        }
      },
    },
  },
};
</script>

<style></style>
